/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Event_GroupInputs */



/**
* | output |
* | --- |
* | "New Event Group" |
*
* @param {New_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_event_group = /** @type {((inputs?: New_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau groupe d’événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Veranstaltungsgruppe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo gruppo di eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новая группа мероприятий")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo grupo de eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新活动组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいイベントグループ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया इवेंट ग्रुप")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo Grupo de Eventos")
	return /** @type {LocalizedString} */ ("New Event Group")
});